import React from "react";
import "./ServicePageShell.css";

export default function ServicePageShell({ children }) {
  return (
    <div className="sps-shell">
      <div className="sps-glow sps-glowLeft" aria-hidden="true" />
      <div className="sps-glow sps-glowRight" aria-hidden="true" />
      <div className="sps-content">{children}</div>
    </div>
  );
}
